import type { OperatingHours } from '../types/supplier.type';

export const WEEKDAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
] as const;

export function formatOperatingHours(
  operatingHours: OperatingHours | null | undefined,
  translateDay: (day: string) => string,
): string {
  if (!operatingHours) return '';
  const days = operatingHours.days.length
    ? [...operatingHours.days].sort((a, b) => WEEKDAYS.indexOf(a as never) - WEEKDAYS.indexOf(b as never)).map(translateDay).join(', ')
    : '';
  const range = operatingHours.start_time && operatingHours.end_time
    ? `${operatingHours.start_time}–${operatingHours.end_time}`
    : '';
  return [days, range].filter(Boolean).join(' · ');
}
